import { useCallback } from 'react'

type ItemsType = {
  sku_id: string | undefined
  item_id: string
  item_name: string
  item_category: string | null
  item_category2: string | null
  item_category3: string | null
  item_category4: string | null
  item_category5: string | null
  item_category6: string | null
  item_collection: string | null
  item_type: string | null
  item_reference: string | null | undefined
  item_material: string | null
  item_brand: string
  item_price: number | undefined
  item_currency: string
  item_size: string | null
  item_stone: string | null
  item_weight: string | null
  item_audience: string | null
  quantity: number
  discount: number
}

type Props = {
  items: ItemsType[]
  user_logged: boolean
  user_id: string | null
  uuid: string | null
}

export const useProductShelfViewItemListEvent = () => {
  window.dataLayer = window.dataLayer || []
  const { dataLayer } = window

  const sendProductShelfViewItemList = useCallback((props: Props) => {
    dataLayer.push({
      event: 'view_item_list',
      items: props.items.map((item) => ({
        sku_id: item.sku_id,
        item_id: item.item_id,
        item_name: item.item_name,
        item_category: item.item_category,
        item_category2: item.item_category2,
        item_category3: item.item_category3,
        item_category4: item.item_category4,
        item_category5: item.item_category5,
        item_category6: item.item_category6,
        item_collection: item.item_collection,
        item_type: item.item_type,
        item_reference: item.item_reference,
        item_material: item.item_material,
        item_brand: item.item_brand,
        item_price: item.item_price,
        item_currency: item.item_currency,
        item_size: item.item_size,
        item_stone: item.item_stone,
        item_weight: item.item_weight,
        item_audience: item.item_audience,
        quantity: item.quantity,
        discount: item.discount
      })),
      user_logged: props.user_logged,
      user_id: props.user_id,
      // uuid: props.uuid,
    })
  }, [])

  return { sendProductShelfViewItemList }
}
